// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const membership = {
  getMembership(page,search,sort_order) {
    return AuthService.get(`/membership/memberships?`+
      `page=${page}` +
      `&sort_order=${sort_order}` +
      `&search=${search}`
    );
  },
  showMembership(id) {
    return AuthService.get(`/membership/memberships/${id}`);
  },
  createMembership(data) {
    return AuthService.post("/membership/memberships", data);
  },
  updateMembership(id, data) {
    return AuthService.put(`/membership/memberships/${id}`, data);
  },
  deleteMembership(id) {
    return AuthService.delete(`/membership/memberships/${id}`);
  }
};
export default membership;
